import FactureAPayerItem from "./FactureAPayerItem";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useFacturesAPayer } from "../../lib/hooks/useFacture";

const BlocFacturesAPayers = () => {
  const [parent] = useAutoAnimate();
  const { data: factures } = useFacturesAPayer();

  if (!factures) return <></>;
  if (factures.length === 0) return <></>;

  return (
    <div className="mb-7 flex flex-col gap-3" ref={parent}>
      {factures.map((fac) => (
        <FactureAPayerItem key={fac.id} facture={fac} />
      ))}
    </div>
  );
};

export default BlocFacturesAPayers;
